module.exports = __webpack_public_path__ + "img/kf.41e56d5b.webp";